<template>
  <section class="search-empty">
    <p class="dsc" v-html="errorMessage" />
  </section>
</template>

<script>
const NO_TAG_DATA_LIST = '선택된 태그가 없어요.\n태그재검색 클릭! 원하는 태그를 선택해 보세요.'
const NO_TAG_SEARCH_DATA_CATEGORY_ALL = '선택한 태그 검색결과가 없어요.\n다른 태그를 선택해 보세요.'

export default {
  name: 'SearchTagEmptyMessage',
  props: {
    pageType: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: 'all'
    }
  },
  computed: {
    tabTitle () {
      const tabTitleMap = {
        all: '',
        program: '프로그램',
        vod: '에피소드',
        movie: '영화'
      }
      return tabTitleMap[this.category]
    },
    hasTagData () {
      return (localStorage.getItem(`search-${this.pageType}`) || '').length > 0
    },
    errorMessage () {
      let message = ''
      const isCategoryAll = this.category === 'all'

      if (!this.hasTagData) {
        message = NO_TAG_DATA_LIST
      } else if (isCategoryAll) {
        message = NO_TAG_SEARCH_DATA_CATEGORY_ALL
      } else {
        message = `선택한 태그 ${this.tabTitle} 검색결과가 없어요.\n다른 태그를 선택해 보세요.`
      }

      return message.replace('\n', '<br />')
    }
  }
}
</script>
